export const SUPPORTED_SOUNDCARDS = ['USB Audio Device', 'Sound Blaster Play! 3']


// WEBPACK FOOTER //
// ./src/constants/supportedSoundcards.js